import { render, staticRenderFns } from "./AccessControlDevice.vue?vue&type=template&id=057a6c40&scoped=true&"
import script from "./AccessControlDevice.vue?vue&type=script&lang=js&"
export * from "./AccessControlDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a6c40",
  null
  
)

export default component.exports